import React from 'react'

export default function SignInTermPolicy() {
  return (
    <div className="flex flex-col items-start">
      <hr className="mb-6 mt-2 w-full" />
      <div className="space-y-2 w-full">
        <div className="flex flex-row justify-between w-full">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://hydrascore.com/privacy-policy/"
            className="text-primary hover:text-blue-800"
          >
            Privacy Policy
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://hydrascore.com/terms-and-conditions"
            className="text-primary hover:text-blue-800"
          >
            Terms of Use
          </a>
        </div>
        <p className="text-sm text-gray-500">
          TM and © {new Date().getFullYear()} Hydra Logic, Inc.
        </p>
      </div>
    </div>
  )
}
